import React from 'react'

const PatientRecords = () => {
  return (
    <div>PatientRecords</div>
  )
}

export default PatientRecords